/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const MEMBERSHIPS_CONTROL_SUBMODULE_SLUG = "memberships-control";
export const MEMBERSHIPS_APPLY_SUBMODULE_SLUG = "apply-membership";
export const MEMBERSHIPS_RENEWALS_SUBMODULE_SLUG = "membership-renewals";
export const MEMBERSHIPS_LIST_SUBMODULE_SLUG = "memberships-list";
export const MEMBERSHIPS_PAYMENTS_SUBMODULE_SLUG = "membership-payments";
/** Student portal — do not gate with staff permission hooks. */
export const MY_MEMBERSHIPS_SUBMODULE_SLUG = "my-memberships";
